import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { TranslationService } from "@app/services/translation.service";
import { EBPMSService } from "../ebpms.service";
import { EBPMSStatus } from "../_models/EBPMSStatus";
import { IBrakePerformanceScoreHistory } from "../_models/IBrakePerformanceScoreHistory";
import "./ebpms-status-summary.component.scss";

@Component({
    selector: 'ebpms-status-summary',
    template: require("./ebpms-status-summary.component.html")
})
export class EBPMSStatusSummaryComponent implements OnChanges, OnInit {
    @Input() vehicleId: number;
    @Input() ebpmsStatus: EBPMSStatus;
    
    @Input() showFullDescription = false;

    title: string;

    currentScore: IBrakePerformanceScoreHistory;
    loading = false;
    oldData = false;
    icon: string;
    
    constructor(private readonly ebpmsService: EBPMSService, private readonly translationService: TranslationService) {
    }

    ngOnInit(): void {
        this.ngOnChanges();
    }

    ngOnChanges(): void {
        this.setTitle();
        this.loadHistory();
        this.setIcon();
    }

    // --- 

    private async loadHistory(): Promise<void> {
        if (!this.vehicleId) {
            console.error("No vehicle ID specified");
            return;
        }

        this.loading = true;
        this.currentScore = await this.ebpmsService.getLatestBrakePerformanceValue(this.vehicleId);
        this.oldData = this.ebpmsService.isLatestEBPMSHistoryOutOfDate(this.currentScore);
        this.loading = false;
    }

    private setTitle(): void {
        switch (this.ebpmsStatus) {
            case EBPMSStatus.Good:
                this.title = this.translationService.t('MaintenanceOverview.StatusSummaryDescriptionGood');
                break;

            default:
                this.title = this.translationService.t('MaintenanceOverview.StatusSummaryDescriptionWarning');
                break;
        }
    }

    private setIcon(): void {
        this.icon = this.ebpmsService.getStatusIcon(this.ebpmsStatus);
    }
}
